"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserChip = void 0;
var react_1 = __importDefault(require("react"));
var Avatar_1 = __importDefault(require("../Avatar"));
var HorizontalSpacer_1 = __importDefault(require("../../utils/HorizontalSpacer"));
var Link_1 = __importDefault(require("../../navigation/Link/Link"));
var TextVerticalSpacer_1 = __importDefault(require("../../utils/TextVerticalSpacer"));
var styles_1 = require("./styles");
var HORIZONTAL_SPACER = {
    '1': { small: 12, medium: 12, large: 12 },
    '2': { small: 8, medium: 8, large: 8 },
};
var AVATAR = {
    '1': { small: 32, medium: 32, large: 32 },
    '2': { small: 24, medium: 24, large: 24 },
};
var BODY_LEVEL = {
    '1': '3',
    '2': '4',
};
var UserChip = function (_a) {
    var name = _a.name, link = _a.link, jobTitle = _a.jobTitle, image = _a.image, _b = _a.level, level = _b === void 0 ? '1' : _b, children = _a.children, commonProps = __rest(_a, ["name", "link", "jobTitle", "image", "level", "children"]);
    var nameComponent = (react_1.default.createElement(styles_1.Body, { level: BODY_LEVEL[level], bold: true }, name));
    var avatarComponent = react_1.default.createElement(Avatar_1.default, { image: image, size: AVATAR[level], backgroundColor: "GREY_10" });
    return (react_1.default.createElement(HorizontalSpacer_1.default, __assign({ "data-component-name": "UserChip" }, commonProps, { amount: HORIZONTAL_SPACER[level], align: "center" }),
        react_1.default.createElement("div", null, link ? (react_1.default.createElement(Link_1.default, __assign({}, link, { block: true }), avatarComponent)) : (avatarComponent)),
        react_1.default.createElement(TextVerticalSpacer_1.default, { level: "6" },
            link ? (react_1.default.createElement(Link_1.default, __assign({}, link, { color: "GREY_90", hoverColor: "BLUE_50", block: true }), nameComponent)) : (nameComponent),
            jobTitle && (react_1.default.createElement(styles_1.Body, { level: BODY_LEVEL[level], color: "GREY_70" }, jobTitle)))));
};
exports.UserChip = UserChip;
exports.default = exports.UserChip;
